import Vue from 'vue'
import FromInstall from './install'

Vue.use(FromInstall)
